import store from "@/store";

import Index from "@/pages/exhibition/Index";
import Home from "@/pages/exhibition/Home";
import Introduction from "@/pages/exhibition/Introduction";
import Origin from "@/pages/exhibition/Origin";
import Past from "@/pages/exhibition/Past";
import Progress from "@/pages/exhibition/Progress";
import Future from "@/pages/exhibition/Future";

export default {
  path: "/exhibition",
  component: Index,
  beforeEnter(to, from, next) {
    store.dispatch("loadPage", "explore-exhibition").then(next);
  },
  meta: {
    label: "Exhibition",
    group: "Stations"
  },
  children: [
    {
      path: "",
      name: "Exhibition Home",
      component: Home,
      meta: {
        label: "Home",
        hide: true
      }
    },
    {
      path: "intro",
      name: "Exhibition Introduction",
      component: Introduction,
      meta: {
        label: "Introduction",
        showSidebar: true
      }
    },
    {
      path: "origin",
      name: "Exhibition Origin",
      component: Origin,
      meta: {
        child: true,
        label: "Origin"
      }
    },
    {
      path: "past",
      name: "Exhibition Past",
      component: Past,
      meta: {
        child: true,
        label: "Past"
      }
    },
    {
      path: "progress",
      name: "Exhibition Progress",
      component: Progress,
      meta: {
        child: true,
        label: "Progress"
      }
    },
    {
      path: "future",
      name: "Exhibition Future",
      component: Future,
      meta: {
        child: true,
        label: "Future"
      }
    }
  ]
};
